<template>
  <div id="NewsPage">
    <van-image class="banner" :src="banner" />
    <no-data v-if="dataList && dataList.length == 0" class="no-data-box" />
    <div v-if="dataList && dataList.length" class="notice-box">
      <div v-for="(item, index) in dataList" :key="index" class="item" @click="toNoticePage(item)">
        <van-image width="25px" height="25px" :src="item.icon" />
        <span class="title">{{ item.itemName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const noticeModules = [
  {
    itemCode: 'stopwater',
    path: '/NewsNotice/NewsList',
    icon: require('../../assets/icon1/notice/tingshui@2x.png')
  }, //停复水公告
  {
    itemCode: 'waterquality',
    path: '/NewsNotice/NewsList',
    icon: require('../../assets/icon1/notice/shuizhi@2x.png')
  }, //水质公告
  {
    itemCode: 'waterfee',
    path: '/NewsNotice/NewsList',
    icon: require('../../assets/icon1/notice/biaozhun@2x.png')
  }, //水价标准
  {
    itemCode: 'policies',
    path: '/NewsNotice/NewsList',
    icon: require('../../assets/icon1/notice/zhengce@2x.png')
  }, //政策法规
  {
    itemCode: 'waterguide',
    path: '/NewsNotice/NewsList',
    icon: require('../../assets/icon1/notice/zhinan@2x.png')
  }, //用水指南
  {
    itemCode: 'orgnews',
    path: '/NewsNotice/NewsList',
    icon: require('../../assets/icon1/notice/qiye@2x.png')
  }, //企业新闻
  {
    itemCode: 'orgIntroduce',
    path: '/NewsNotice/NewsList',
    icon: require('../../assets/icon1/notice/wangdian@2x.png')
  }, //企业介绍
  {
    itemCode: 'help',
    path: '/NewsNotice/NewsList',
    icon: require('../../assets/icon1/notice/wangdian@2x.png')
  }, //使用帮助
  {
    itemCode: 'yszc',
    path: '/NewsNotice/NewsList',
    icon: require('../../assets/icon1/notice/wangdian@2x.png')
  } //隐私政策
];

import NoData from '@/components/noData';
import { getNoticeMenu } from '@/api/user';
export default {
  name: 'NewsList',
  components: {
    NoData
  },
  data() {
    return {
      banner: require('./notice_banner.png'),
      dataList: undefined
    };
  },
  mounted() {
    this.getNotice();
  },
  methods: {
    // 获取公告列表信息
    async getNotice() {
      const { status, resultData } = await getNoticeMenu();
      this.dataList = [];
      if (status === 'complete' && resultData?.length > 0) {
        resultData.forEach(element => {
          noticeModules.forEach(item => {
            if (element.itemCode === item.itemCode) {
              this.dataList.push(Object.assign(element, item));
            }
          });
        });
      }
    },
    // 进入公告列表页面
    toNoticePage(item) {
      this.$router.push({
        path: item.path,
        query: {
          noticeType: item.itemCode,
          pageTitle: item.itemName
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
#NewsPage {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background-color: #f7f7f7;
}

.no-data-box {
  box-sizing: border-box;
  border-radius: 8px;
  box-shadow: 2px 2px 4px 0 rgba(213, 218, 225, 0.3);
  background-color: #fff;
  float: left;
  z-index: 2;
  padding: 15px;
  width: 90vw;
  margin-left: 5vw;
  margin-right: 5vw;
  margin-top: -70px;

  div:first-child {
    font-size: 16px;
    font-weight: 700;
    text-align: center;
  }

  /deep/ .noData {
    margin-top: 3% !important;
  }
}

/deep/ .van-image {
  position: static;
}

.notice-box {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  background: #fff;
  padding: 10px 8px 0 10px;
  box-sizing: border-box;
  z-index: 2;
  float: left;
  border-radius: 8px;
  width: 90vw;
  margin-left: 5vw;
  margin-right: 5vw;
  margin-top: -70px;

  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 45%;
    height: 75px;
    padding-left: 16px;
    margin-bottom: 10px;
    border-radius: 2px;
    background-image: url('./notice_item.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .title {
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      margin-left: 10px;
    }
  }
}

.banner {
  width: 100vw;
  z-index: 1;
  float: left;
  margin-top: -30px;
}
</style>
